import karteCustonEventClient from './karte/custom_event';

document.addEventListener('DOMContentLoaded', () => {
  const helpLinks = document.querySelectorAll('.to-help, .to-help-in-form');
  if (!helpLinks.length) {
    return;
  }

  const sendKarteEvent = (event_name: string, content_name: string, message: string) => {
    // 更新したことをKARTEに通知
    karteCustonEventClient.sendEvent({
      event_name: event_name,
      content_name: content_name,
      message: message
    });
  }

  [].forEach.call(helpLinks, helpLink => {
    const aTag = (helpLink as HTMLElement).querySelector('a') as HTMLElement;
    const href = aTag.getAttribute('href');
    const linkText = aTag.textContent;
    // クリック時に実行
    aTag.addEventListener('click', () => {
      // KARTEに登録イベントを送信
      sendKarteEvent(
        'click_link',
        'help_link',
        linkText + ' (' + href + ') ' + 'をクリックしました'
      );
    })
  });
});
